import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import "../style/auth.css";

const UnlockAccountPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const email = searchParams.get("email") || "";
  const token = searchParams.get("token") || "";

  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState("verifying"); // 'verifying' | 'success' | 'error'
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (!email || !token) {
      setStatus("error");
      setMessage("Invalid account unlock link. Missing email or token.");
      setLoading(false);
      return;
    }

    const unlockAccount = async () => {
      try {
        const response = await fetch("/api/auth/unlock-account", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email, token }),
        });
        const data = await response.json();

        if (response.ok && data.success) {
          setStatus("success");
          setMessage(data.message || "Your account has been unlocked successfully!");
        } else {
          setStatus("error");
          setMessage(data.error || "Failed to unlock account. Token may be invalid or expired.");
        }
      } catch (err) {
        setStatus("error");
        setMessage("An unexpected error occurred. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    unlockAccount();
  }, [email, token]);

  return (
    <div className="auth-container" style={{ minHeight: "80vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <div className="auth-card" style={{ maxWidth: "480px", width: "100%", padding: "2.5rem", textAlign: "center", borderRadius: "12px", background: "#ffffff", boxShadow: "0 10px 25px rgba(0,0,0,0.08)" }}>
        {loading ? (
          <div>
            <div style={{ width: "40px", height: "40px", border: "4px solid #E2E8F0", borderTopColor: "#F5821F", borderRadius: "50%", animation: "spin 0.8s linear infinite", margin: "0 auto 1.5rem" }} />
            <h2 style={{ fontSize: "1.25rem", color: "#1E293B", marginBottom: "0.5rem" }}>Unlocking Account</h2>
            <p style={{ color: "#64748B", fontSize: "0.95rem" }}>Verifying your security credentials...</p>
          </div>
        ) : status === "success" ? (
          <div>
            <div style={{ width: "56px", height: "56px", borderRadius: "50%", background: "#DCFCE7", color: "#16A34A", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 1.5rem", fontSize: "1.75rem" }}>
              ✓
            </div>
            <h2 style={{ fontSize: "1.5rem", color: "#0F172A", fontWeight: "700", marginBottom: "0.75rem" }}>Account Unlocked!</h2>
            <p style={{ color: "#475569", fontSize: "0.95rem", lineHeight: "1.6", marginBottom: "1.75rem" }}>{message}</p>
            <button
              onClick={() => navigate("/login")}
              style={{ width: "100%", padding: "0.85rem", borderRadius: "8px", border: "none", background: "#F5821F", color: "#FFF", fontWeight: "600", fontSize: "1rem", cursor: "pointer" }}
            >
              Sign In Now
            </button>
          </div>
        ) : (
          <div>
            <div style={{ width: "56px", height: "56px", borderRadius: "50%", background: "#FEE2E2", color: "#DC2626", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 1.5rem", fontSize: "1.75rem" }}>
              ✕
            </div>
            <h2 style={{ fontSize: "1.5rem", color: "#0F172A", fontWeight: "700", marginBottom: "0.75rem" }}>Unlock Failed</h2>
            <p style={{ color: "#475569", fontSize: "0.95rem", lineHeight: "1.6", marginBottom: "1.75rem" }}>{message}</p>
            <div style={{ display: "flex", gap: "1rem" }}>
              <Link to="/login" style={{ flex: 1, padding: "0.75rem", textAlign: "center", borderRadius: "8px", border: "1px solid #CBD5E1", color: "#334155", fontWeight: "600", textDecoration: "none" }}>
                Back to Sign In
              </Link>
              <Link to="/contact" style={{ flex: 1, padding: "0.75rem", textAlign: "center", borderRadius: "8px", background: "#0F172A", color: "#FFF", fontWeight: "600", textDecoration: "none" }}>
                Contact Support
              </Link>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default UnlockAccountPage;
